export default {
  common: {
    yes: 'Ja',
    no: 'Nee',
    ok: 'OK',
    close: 'Sluiten',
    logout: 'Afmelden',
    confirm: 'Bevestig',
    continue: 'Ga verder',
    sendAgain: 'Stuur opnieuw',
    serverError: 'Serverfout'
  },
  errors: {
    unknownEmail: 'onbekend e-mail adres',
    minGroupSize: (ctx) => `Minimale groepsgrootte is ${ctx.named('value')} personen`,
    reservationNotFound: 'Reservering met een dergelijk nummer kon niet worden gevonden'
  },
  ui: {
    select: {
      clear: 'Clear'
    },
    validator: {
      required: 'Verplicht veld',
      phoneOrEmailRequired: 'Phone number or Email are required',
      phoneOrEmailOrReservationRequired: 'Missing phone number/email or reservation number',
      badPhone: 'Voer een echt telefoonnummer in',
      badEmail: 'Voer een correct e-mailadres in',
      badOtp: 'Voer een 6-cijferige code in'
    },
    loading: {
      reservation: 'Reservering...',
      reservationUpdate: 'Reservering bijwerken...',
      reservationCancel: 'Reservering annuleren...'
    }
  },
  forms: {
    signin: 'Sign In',
    signup: 'Sign Up',
    profile: 'Profile',
    otpTokenRequest: 'Please enter your code',
    fields: {
      firstName: 'Voornaam',
      lastName: 'Achternaam',
      // phone: 'Telefoon',
      phone: 'Tel',
      email: 'Email',
      otpCode: 'Code',
      reservationNumber: 'Reserverings num.', // 'Reserverings nummer'
      wheelchair: 'Rolstoel',
      highchair: 'Kinderstl'
    },
    checkboxes: {
      subscribe: 'Meld mij aan voor aanbiedingen en nieuws',
      rememberme: 'Onthoud mij op dit apparaat'
    }
  },
  pages: {
    index: {
      heading1: 'Leuk dat je bij ons komt eten!',
      // heading2: 'Je kunt weer reserveren voor een tafel in ons restaurant. Voor ons terras kun je alleen ter plekke reserveren.',
      heading2: 'Je kunt weer reserveren voor een tafel in ons restaurant.',
      heading3: 'Wanneer kom je langs?',
      today: 'Vandaag',
      tomorrowOrLater: 'Morgen of later',
      xmas: 'Kerst',
      start: 'Start',
      changeReservation: 'Wijzig of annuleer bestaande reservering',
      form: {
        partySize: 'Met hoeveel personen kom je eten?',
        when: 'Welk moment kom je langs?',
        location: 'Waar wil jij aan tafel?'
      }
    },
    filter: {
      partySize: 'Met hoeveel personen kom je eten?',
      partySizeHint: (ctx) => `Maximale groepsgrootte ${ctx.named('value')} personen.`,
      when: 'Welk moment kom je langs?',
      location: 'Waar wil jij aan tafel?',

      //       Helaas hebben wij geen tafel meer beschikbaar. Wil je toch graag komen eten?
      // Kies dan een andere locatie of datum of kom gezellig langs en kijk of er nog een plek vrij is gekomen binnen of op het terras.

      noSlots: (ctx) => {
        let partySize = ctx.named('partySize') || 2
        let text = ''

        switch (true) {
          case partySize < 7:
            text = `Bij Loetje kom je altijd aan tafel. Je kunt altijd eerst een drankje drinken aan de bar en komt vaak snel aan tafel. Dus kom lekker langs!`
            break
          case partySize >= 7:
            text = `Bij Loetje kom je altijd aan tafel. Je kunt altijd eerst een drankje drinken aan de bar en komt vaak snel aan tafel. Dus kom lekker langs!`
            break
        }

        return text
      },
      noSlotsDescription: 'Wist je dat je gewoon langs mag komen voor een plekje op ons terras?',
      bqtProposalText: 'Groter gezelschap?',
      bqtProposalHint: (ctx) => `
        Onderstaand vind je de locaties in de buurt waar je direct
        kan reserveren voor een groter gezelschap of neem contact op,
        wij kijken graag met je mee.
        (<a href="tel:${ctx.named('phone')}" target="${ctx.named('target') || '_self'}">${ctx.named('phone')}</a>)
        (van 9:00-21:00)
      `,
      goBqtFooterHint: (ctx) => `
        Samen een geschikte locatie en een passend arrangement uitzoeken?
        Wij kijken graag met je mee
        (<a href="tel:${ctx.named('phone')}" target="${ctx.named('target') || '_self'}">${ctx.named('phone')}</a>)
        (van 9:00-21:00)
      `,
      selectLocation: 'Selecteer een lokatie om beschikbaarheid op te halen',
      noAlternatives: 'Er zijn geen alternatieve Loetje locaties beschikbaar.',
      changeDate: 'Kies een andere datum waarop je bij ons aan wilt schuiven.',
      allRestaurantsClosed: `Wegens ons jaarlijkse personeelsfeest zijn
        alle Loetje vestigingen op maandag 6 januari gesloten. <br>
        We verwelkomen je graag op een andere dag!
      `,
      chooseRestaurant: 'Selecteren',
      xmasHint: (ctx) => `
        <p class="q-mb-sm">Loetje biedt diverse mogelijkheden om tijdens de kerstdagen te komen dineren.</p>
        <p class="q-mb-sm">We informeren je graag over de beste opties!</p>
        <p class="q-mb-sm">
          <a href="${ctx.named('url')}" target="${ctx.named('urlTarget') || '_blank'}">Klik hier</a>
          om ons kerstmenu te zien en een reservering te plaatsen.
        </p>
        <p class="q-mb-sm">Wil je liever telefonisch contact opnemen? Dat kan!</p>

        <p class="q-mb-sm">
          <a href="tel:${ctx.named('phone')}" target="${ctx.named('target') || '_self'}">
            ${ctx.named('phone')}
          </a>
        </p>
      `,
      hilversumTemporaryText: (ctx) => `
        <p>Vrijdag 1 december openen we ons nieuwste restaurant in het gezellige centrum van Hilversum.</p>
        <p>We heten je van harte welkom om hier te komen genieten van onze biefstuk en andere lekkere gerechten.</p>
        <p>Je kunt nu alvast een reservering maken (ook voor de feestdagen) door te bellen naar <strong>035-2002838</strong> of online:</p>
        <p>Tot snel!</p>
      `,
      buttons: {
        proceed: 'Vul je gegevens in',
        goBqt: 'Groepsaanvraag (configurator)',
        goBqtAlt: 'Stel hier je arrangement samen',
        reserve: 'Reserveer nu',
        lunchOnXmas: 'Lunch',
        dinnerOnXmas: 'Diner',
        callUs: (ctx) => `
          Bel ons: ${ctx.named('phone')}
        `
      }
    },
    results: {
      description: `Loop gerust binnen zonder reservering.<br>
        Alle Loetje Restaurants hebben een gezellige bar
        waar je wat kunt drinken voordat je aan tafel komt.`
    },
    reservation: {
      heading: 'Vul je gegevens in:',
      headingForAuthenticated: 'Je gegevens:',
      headingForUpdate: 'Wijzig je reservering:',
      undefinedLocation: 'Ongedefinieerde locatie',
      dateNotAvailable: 'Deze datum is niet beschikbaar',
      noAvailableTimes: (ctx) => `
        <strong>Helaas is er geen beschikbaarheid online voor het gewenste aantal gasten.
        Neem telefonisch contact met ons op, wij kijken graag met je mee.
        <a href="tel:${ctx.named('phone')}" target="${ctx.named('target') || '_self'}">${ctx.named('phone')}</a> (van 9:00-21:00)</strong>
        <br><br>
        <strong>Heb je een aanvraag gedaan voor een groep groter dan 14 gasten? Neem dan contact op met ons team via de mail die je hebt ontvangen met de offerte. (<a href="mailto:events@rce.eu">events@rce.eu</a>)</strong>
      `,
      buttons: {
        proceed: 'Volgende stap'
      }
    },
    checkInfo: {
      heading: 'Controleer hieronder je gegevens',
      reservationInfo: (ctx) => `
        Ik kom eten bij
        <strong>${ctx.named('location')}</strong>
        op <strong>${ctx.named('date')}</strong>
        om <strong>${ctx.named('time')}</strong>
        met <strong>${ctx.named('party_size')}</strong> personen.
        <br><br>
        Mijn naam is ${ctx.named('first_name')} ${ctx.named('last_name')},
        email <strong>${ctx.named('email')}</strong>,
        telefoonnummer <strong>${ctx.named('phone_number')}</strong>
      `,
      // rolstoel <strong>${ctx.named('wheelchair_users') ? 'JA' : 'NEE'}</strong>,
      // kinderstoel <strong>${ctx.named('child_seats') ? 'JA' : 'NEE'}</strong>
      buttons: {
        approve: 'Volgende stap',
        changeDetails: 'Wijzig mijn gegevens'
      }
    },
    codeInput: {
      heading: 'Je bent er bijna, dit is de laatste stap.',
      info: (ctx) => {
        let wayToCommunicate = ctx.named('wayToCommunicate') || 'email',
          wayString = (wayToCommunicate === 'phone_number') ? 'SMS' : 'email'
        return `
          Je reservering is bijna klaar!<br>
          We hebben je een ${wayString} gestuurd met een 6-cijferige code.<br>
          Voer deze code hieronder in om de reservering te bevestigen.
        `
      },
      infoForRetrieve: 'We sturen nu je code naar:',
      checkYourData: (ctx) => {
        let wayToCommunicate = ctx.named('wayToCommunicate') || 'email'
        return (wayToCommunicate === 'email')
          ? `
            Geen email ontvangen?<br>
            Check je spam folder en controleer je e-mailadres hieronder:
          `
          : ''
      },
      buttons: {
        change: 'wijzig',
        confirm: 'Bevestig mijn reservering',
        resend: 'Stuur opnieuw'
      },
      successMessage: 'Code is succesvol verzonden'
    },
    preProcess: {
      heading: 'Let op',
      info: (ctx) => `
        Je hebt een ander email adres ingevuld dan je eerder hebt gebruikt met dit telefoonnummer.
        <br><br>
        Wil je dit nieuwe email adres gebruiken voor deze reservering?
        <br><br>
        Huidig: <span class="text-weight-medium">${ctx.named('oldEmail')}</span><br>
        Nieuw: <span class="text-weight-medium">${ctx.named('newEmail')}</span>
      `,
      buttons: {
        ok: 'Ja',
        no: 'Nee'
      }
    },
    yourCode: {
      heading: 'Bevestig je reservering',
      info: `Leuk dat je bij Loetje wilt komen eten! Om je reservering te bevestigen,
        vragen we je om de onderstaande verificatiecode in te vullen op de website.`,
      yourCode: 'Jouw code',
      buttons: {
        confirm: 'Bevestig je reservering'
      },
      hint: `Heb je geen reservering bij Loetje gemaakt?<br>
        Dan kan je deze mail negeren.`
    },
    reservationSuccess: {
      heading: 'Bedankt voor je reservering',
      info: `Leuk dat je langskomt.<br>
        We hebben er zin in!`,
      reservationNumber: 'Jouw reserveringsnummer is:',
      copySuccessMessage: 'Reserveringsnummer gekopieerd naar klembord',
      extraInfo: (ctx) => {
        return ctx.named('email')
          ? `
            Een bevestiging van deze reservering
            is gestuurd naar <span class="text-weight-medium">${ctx.named('email')}</span>
          `
          : ''
      },
      buttons: {
        goHome: 'Ga naar Loetje.nl'
      }
    },
    reservationFailed: {
      error409: 'Deze tijd is helaas niet meer te boeken',
      errorOneTimeDealCodeAlreadyUsed: 'Er is helaas een fout opgetreden. Deze actielink is al gebruikt voor een reservering',
      errorBadOneTimeDealCode: 'Er is helaas een fout opgetreden. Gebruik alstublieft de reserveringslink uit uw e-mail om te boeken',
      buttons: {
        chooseAnotherTime: 'Start opnieuw'
      }
    },
    reservations: {
      list: {
        heading: 'Jouw reserveringen',
        caption: 'Wijzigen? Klik op je reservering:',
        itemCaption: (ctx) => `
          ${ctx.named('date')},
          om ${ctx.named('time')}
        `,
        empty: 'Er zijn geen reserveringen',
        cancel: 'Tafel annuleren',
        signout: 'Uitloggen',
        edit: 'Bewerk',
        updateSuccessMessage: 'Uw reservering is succesvol gewijzigd'
      },
      cancel: {
        confirmation: 'Weet je zeker dat je deze<br> reservering wilt annuleren?',
        cancellation_disabled: (ctx) => `
          Sorry, u kunt de reservering op dit moment niet annuleren. <br>
          Neem rechtstreeks contact op met het restaurant:
          <a href="tel:${ctx.named('phone')}" target="${ctx.named('target') || '_self'}" class="text-white text-bold text-underline">
          ${ctx.named('phone')}</a>
        `,
        buttons: {
          confirm: 'Ja, annuleer mijn reservering',
          goHome: 'Ga naar Loetje.nl'
        }
      },
      cancelSuccess: {
        heading: 'Je reservering is geannuleerd',
        info: (ctx) => `
          Een bevestiging van deze annulering is gestuurd naar
          <span class="text-weight-medium">${ctx.named('email')}</span>
        `,
        buttons: {
          reservationsList: 'Mijn reserveringslijst',
          goHome: 'Ga naar Loetje.nl'
        }
      },
      retrieve: {
        // heading: 'Vul je reserveringnummer in om je reservering te beheren, of log in met email adres:',
        heading: 'Vul je reserveringnummer in om je reservering te beheren, of log in met telefoonnummer:',
        issues: {
          invalidConfirmationNumber: 'Ongeldig bevestigingsnummer'
        }
      }
    },
    users: {
      update: {
        heading: 'Laatste stap!',
        info: 'Vul hieronder je emailadres in om jouw reserveringsbevestiging te ontvangen',
        buttons: {
          confirm: 'Ja, maak mijn reservering definitief'
        }
      },
      codeInput: {
        heading: 'Bevestig je update',
        info: `We hebben je een sms gestuurd met een 6-cijferige code.<br>
          Voer deze code hieronder in om het bijwerken van de e-mail te bevestigen.`,
        buttons: {
          confirm: 'Bevestigen',
          resend: 'Stuur opnieuw'
        }
      },
      updatingSuccess: {
        heading: 'E-mail is succesvol geüpdatet',
        info: `Leuk dat je bij ons komt eten!`,
        extraInfo: (ctx) => {
          return ctx.named('email')
            ? `
              Een bevestiging van deze reservering is gestuurd naar: ${ctx.named('email')}
            `
            : ''
        },
        buttons: {
          goHome: 'Ga naar Loetje.nl'
        }
      }
    }
  },
  locationSelector: {
    choosenLocation: 'Gekozen locatie:',
    changeLocation: 'Change location',
    description: 'Please send your location details?',
    autoSelect: 'Yes (send location data automatically)',
    manualSelect: 'No (I will choose my location myself)',
    requestCoordinates: 'Select your location.'
  },
  groupSizePicker: {
    label: '{value} persoon | {value} personen'
  },
  restaurantInfoBlock: {
    address: 'Adresgegevens',
    parking: 'Parkeergelegenheid',
    experiences: 'Ervaringen',
    route: 'Route',
    openingHours: 'Openingstijden',
    bages: {
      pets: 'Honden aangelijnd welkom',
      accessible: 'Invalide toilet aanwezig',
      terrace: 'Terras&nbsp;<strong>niet</strong>&nbsp;te reserveren'
    }
  },
  alternativesList: {
    heading: `<br>
      Bekijk beschikbaarheid bij overige Loetjes:`
  },
  restaurantsCard: {
    buttons: {
      changeLocation: 'Ik wil hier aan tafel',
      moreInformation: 'Meer informatie'
    }
  },
  reservationInfoPanel: {
    addToCalendar: 'Voeg toe aan agenda',
    route: 'Route',
    newReservation: 'Nieuwe reservering'
  },
  timeSlotPicker: {
    sessionHeading: 'Je wilt:',
    timeHeading: 'Kies je gewenste tijd:',
    timeHeadingForBigGroups: 'Op het moment ontvangen we groepen graag op enkele vaste tijdstippen:',
    emptyList: 'Lege lijst',
    availableTimeslotText: 'Reserveer nu!',
    unavailableTimeslotText: 'Kom je langs?',
    unavailableTimeslotHint: (ctx) => {
      // const sid = ctx.named('sid') || 'default'
      // default text
      let text = `Kom gezellig bij ons binnen zonder reservering!<br />
        Mocht er niet direct een tafel beschikbaar zijn,
        dan kan je alvast een drankje drinken aan de bar,
        terwijl wij zorgen dat je zo snel mogelijk aan tafel komt. Zien we je zo?`
      return text
    },
    unavailableTimeslotHint2: (ctx) => `Ben je geïnteresseerd in de beschikbaarheid
      bij één van onze andere Loetje locaties?
      Onderstaand vind je de locaties in de buurt of neem contact op,
      wij kijken graag met je mee.
      (<a href="tel:${ctx.named('phone')}" target="${ctx.named('target') || '_self'}">${ctx.named('phone')}</a>)
      (van 9:00-21:00)
    `,

    unavailableTimeslotTextXmas: 'Volgeboekt',
    unavailableTimeslotHintXmas: (ctx) => {
      // default text
      let text = `Helaas is het restaurant volgeboekt op deze tijd.
        Bekijk de beschikbaarheid
        op andere tijden of selecteer een van onze overige locaties.`
      return text
    },
    unavailableTimeslotHint2Xmas: (ctx) => `Liever even bellen? Dat kan natuurlijk ook.
      Onze medewerkers adviseren je
      graag over de beste mogelijkheden o.b.v. jouw voorkeurslocatie(s).<br>
      Call <a href="tel:+310202088000" target="${ctx.named('target') || '_self'}">
      +31 (0) 20 208 8000</a> (van 9:00 - 21:00)
    `,

    terraceProposition: `<strong>Terras</strong><br>
      <span class="text-italic">Fijn dat je bij Loetje komt eten. We reserveren een tafel binnen voor je.</span>`
  },
  timeSlotInput: {
    time: 'Tijd'
  },
  sessionsList: {
    breakfast: 'Ochtend',
    lunch: 'Middag',
    dinner: 'Avond',
    morning: 'Ochtend',
    afternoon: 'Middag',
    evening: 'Avond'
  }
}
